import { render, staticRenderFns } from "./StoreProducts.vue?vue&type=template&id=27d33a51"
import script from "./StoreProducts.vue?vue&type=script&lang=js"
export * from "./StoreProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports